import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="12" fill="none" {...props}><path fill="#C4C4C4" d="M17.454 12V0l-5.959 4.945 3.096 3.835-.091.099-3.586-3.449-2.187 1.814L6.541 5.43 2.955 8.88l-.091-.1 3.09-3.834L0 .01V12h17.454z" /><path fill="#C4C4C4" d="M17.454 0H0l8.734 6.545L17.454 0z" /></svg>);